document.addEventListener(
    "DOMContentLoaded", () => {
        if (document.querySelector( "#my-menu" )) {
            const menu = new MmenuLight(
                document.querySelector( "#my-menu" )
            );
    
            const navigator = menu.navigation();
            const drawer = menu.offcanvas();
    
            navigator.openPanel(
                document.querySelector( "#my-ul" )
            );
            
            const burgerBtn =  document.querySelectorAll( "button.hamburger" );
            const targetNode = document.querySelector('body');
            const config = { attributes: true, childList: false, subtree: false  };
            
            burgerBtn.forEach(btn => {
                const callback = function(mutationsList, observer) {
                    for(const mutation of mutationsList) {
                        if (mutation.type === 'attributes') {
                            if(!targetNode.classList.contains("mm-ocd-opened")) {
                                btn.classList.remove("is-active");
                                observer.disconnect();
                            }
                        }
                    }
                };
        
                const observer = new MutationObserver(callback);
        
                btn.addEventListener( "click", ( evnt ) => {
                    evnt.preventDefault();
                    btn.classList.add("is-active");
                    drawer.open();
                    observer.observe(targetNode, config);
                });
            });
        }
    }
);

